/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useMemo, useState, useEffect } from 'react';
import clsx from 'clsx'
import { handleNumInput } from '../helpers';
import { times } from 'lodash';

import { useDebounce } from '../../../_metronic/helpers';

type Props = {
    isLoading: boolean,
    updateState: any,
    state: any
}

const TablePagination : FC<Props> = ({ isLoading, updateState, state }) => {


    const [pageNo, setPageNo] = useState<string>('')    

    
    const { npages, offset, show_cnt, from, to, atFirst, atLast, page, nrecs, items_per_page } = useMemo(() => {

        const { nrecs, page, items_per_page } = state;

        const npages = Math.ceil(nrecs / items_per_page);
        
        const offset = (page < 6 ) ? 1 : (page + 5 > npages ?  npages - 4: page - 2);

        const show_cnt = (npages - offset + 1) < 5 ? npages - offset + 1 : 5;

        
        const atFirst = (page === 1);
        const atLast = (page === npages);
        
        const to = (atLast) ? nrecs : (page) * items_per_page;            
        const from = (atFirst) ? 1 : ((page-1) * items_per_page) + 1;                                        
        
        setPageNo((page > npages) ? `${npages}` : '');
        
        return {npages, offset, show_cnt, from, to, atFirst, atLast, page, nrecs, items_per_page};
    }, [state]);
      
        
        
    const updatePage = (new_page: any) => {

        if (!new_page || isLoading ) return;
                
        setPageNo('');
        
        let page_no = parseInt(new_page);
                        
        if (page_no < 1) {
            page_no = 1;                            
        } else if (page_no > npages) {
            page_no = npages;                                
        }            
        
        if (page_no === page) return;

        updateState({ page: page_no });        
    }            
        

    const debouncedPageNo = useDebounce(pageNo, 400);

    useEffect(() => {
        updatePage(debouncedPageNo);        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedPageNo] );


    return (
    <div className='d-flex flex-stack flex-wrap justify-content-between pt-10 gap-2 '>
        { (nrecs > 0) && 
        <div className='fs-7 text-gray-600 py-2 me-6'>
            { nrecs === 1 ? (
                'Showing 1 of 1 record'
            ) : (
                `Showing ${from} to ${to}`
            )}
            { (nrecs > 1) &&
            <span> of <span className="fw-bold">{`${nrecs}`}</span> records</span>
            }            
        </div>
        }

        {(npages > 1) && 
        <div className="align-self-end d-flex flex-row align-items-center gap-2">
            <ul className='pagination fs-10 gap-1'>
                <li
                    className={clsx('page-item', {
                        disabled: isLoading,                    
                    })}
                >
                    <a
                        className={clsx('page-link page-text', 
                        {'text-muted': atFirst})}
                        onClick={() => updatePage(1)}
                        style={{cursor: 'pointer'}}
                    >
                        First
                    </a>
                </li>
                <li
                    className={clsx('page-item previous', {
                        disabled: isLoading,                    
                    })}
                >
                    <a
                        className={clsx('page-link page-text', 
                        {'text-muted': atFirst})}
                        onClick={() => updatePage(page > 1 ? page - 1 : 1)}
                        style={{cursor: 'pointer'}}
                    >
                        Previous
                    </a>
                </li>
                {
                    times(show_cnt, (no) => (
                    <li
                        key={`page${no}`}
                        className={clsx('page-item', {
                            active: page === (no + offset),
                            disabled: isLoading,                                
                        })}
                    >
                        <a
                            className='page-link'
                            onClick={() => updatePage(no + offset)}
                            style={{cursor: 'pointer'}}
                        >
                            {`${no + offset}`}
                        </a>
                    </li>
                    ))
                }
                <li
                    className={clsx('page-item next', {
                        disabled: isLoading,                    
                    })}
                >
                    <a
                        className={clsx('page-link page-text', { 'text-muted': atLast})}
                        onClick={() => updatePage(page + 1 < npages ? page + 1 : npages)}
                        style={{cursor: 'pointer'}}
                    >
                        Next
                    </a>
                </li>   
                <li
                    className={clsx('page-item next', {
                        disabled: isLoading,                    
                    })}
                >
                    <a
                        className={clsx('page-link page-text',{'text-muted' : atLast})}
                        onClick={() => updatePage(npages)}
                        style={{cursor: 'pointer'}}
                    >
                        Last
                    </a>
                </li>   
            </ul>       
            { npages > 5 && 
            <div className="d-flex flex-row align-items-center gap-2 fs-7 ms-4">
                <label>Go To:</label>
                <input 
                    type="text"                     
                    className="form-control form-control-sm border-1 w-50px text-center py-1 fs-7"
                    onKeyDown={handleNumInput}
                    name="page_no"
                    value={pageNo}
                    onChange={(e) => {
                        setPageNo(e.target.value);
                    }}
                />
            </div>
            }                                 
        </div>
        }        
        { (nrecs > 10) &&    
        <div className="d-flex flex-row align-items-center gap-2 fs-7">
            <label>Show:</label>
            <select
                className="form-control border-1 fs-7 py-1"
                onChange={(e) => {
                    //@ts-ignore
                    updateState({items_per_page : parseInt(e.target.value)})
                }}
                name="items_per_page"
                value={`${items_per_page}`}
            >
                <option>10</option>                
                <option>20</option>
                <option>30</option>
                { (nrecs > 30) &&    
                <option>50</option>
                }
                { (nrecs > 50) &&    
                <option>100</option>
                }
                { (nrecs > 100) &&    
                <option>500</option>
                }
            </select>
        </div>
        }
    </div>        
    )
}

export {TablePagination}
